module.exports = __webpack_public_path__ + "img/endorphina.6b6f11c8.svg";